<template>
	<div class="native-credentials-form">
		<div class="d-flex">
			<TextField
				:value="value"
				label="Base64 Key *"
				placeholder="Enter your Base64 encoded key"
				class="flex-grow-1 mr-2"
				:rules="{ required: true }"
				@input="$emit('input', $event)"
			/>
			<SecondaryActionButton
				outlined
				@click="$emit('generate')"
			>
				Generate
			</SecondaryActionButton>
		</div>
		<div class="text-caption text--secondary mt-1">
			Provide your Base64 encoded AES encryption key (256-bit / 32 bytes)
		</div>
	</div>
</template>

<script>
import SecondaryActionButton from '../../../../../shared/components/secondary-action-button.vue'
import TextField from '../../../../../shared/components/text-field.vue'

export default {
	name: 'native-credentials-form',

	components: {
		SecondaryActionButton,
		TextField
	},

	props: {
		value: {
			type: String,
			default: ''
		}
	}
}
</script>
